import { all, takeEvery, put, call } from 'redux-saga/effects'
import lessonsApi from 'services/lessons'
import { actions } from './actions'

export function* loadLessons(subtopicId) {
  try {
    const response = yield call(lessonsApi.loadLessons, subtopicId.payload)

    yield put({
      type: actions.LOAD_LESSONS_RESULT,
      payload: response,
    })
  } catch (error) {
    yield put({
      type: actions.LOAD_LESSONS_RESULT,
      error,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_LESSONS_REQUEST, loadLessons)])
}
